import {
  Autocomplete,
  CircularProgress,
  FormControl,
  FormGroup,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { BlackDuckProjectGroup } from "../../../../app/backendTypes";

export default function BlackDuckProjectPicker(props: {
  projectGroups: BlackDuckProjectGroup[];
  loading: boolean;
  error: string | undefined;
  onChange: (val: BlackDuckProjectGroup | null) => void;
  initialValue: BlackDuckProjectGroup | null;
}) {
  const { projectGroups, loading, error, onChange, initialValue } = props;

  const theme = useTheme();

  return (
    <FormControl fullWidth>
      <FormGroup>
        <Autocomplete
          value={initialValue}
          isOptionEqualToValue={(o, v) => o.id === v.id}
          size="small"
          disabled={loading || Boolean(error)}
          options={projectGroups}
          getOptionLabel={(project) => project.name}
          renderOption={(props, project) => (
            <Typography {...props}>{project.name}</Typography>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
              placeholder={
                loading ? "Loading..." : error ? "Error" : "Pick a project"
              }
              error={Boolean(error)}
              sx={{
                input: {
                  "&::placeholder": {
                    color: Boolean(error)
                      ? theme.palette.error.main
                      : "text.secondary",
                    opacity: 1,
                  },
                },
              }}
            />
          )}
          onChange={(_, value) => onChange(value)}
        />
      </FormGroup>
    </FormControl>
  );
}
